import { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetAccountInfoQuery } from 'views/utils/graphql/graphql';
import { checkNeedLoginPath } from 'views/constants/enums/pageTitle';

export enum ForceInputStep {
    NotLogin,
    ChangePassword,
    AgreementDocument,
  }

export const useLayout = () => {
    const location = useLocation();
    const [step, setStep] = useState<ForceInputStep>(ForceInputStep.NotLogin);
    const isNeedLoginPath = checkNeedLoginPath(location.pathname);
  
    const [accountInfo, getAccountInfo] = useGetAccountInfoQuery({
      requestPolicy: 'network-only',
      pause: !isNeedLoginPath, //ログインしていないページの場合は何もしない
    });
  
    useEffect(() => {
      if (!isNeedLoginPath) {
        setStep(ForceInputStep.NotLogin);
      }
    }, [isNeedLoginPath]);
  
    useEffect(() => {
      if (accountInfo.fetching) return;
      if (accountInfo.data?.GetAccountInfo?.ChangedPassword === false) {
        setStep(ForceInputStep.ChangePassword);
      } else {
        setStep(ForceInputStep.AgreementDocument);
      }
    }, [accountInfo]);
  
    const changePasswordComplete = useCallback(() => {
      // リクエストが増えてしまうが古い情報を残したくないのでリロードする
      getAccountInfo();
    }, [getAccountInfo]);

    return ({
        step,
        changePasswordComplete
    });
}